export default __webpack_public_path__ + "locales/it/SocialAuthWelcomeDialog.json?hash=66c610e1f9c034a3d8a887060757a4fe";